<template>
  <div class="paginated-list" data-test-id="paginated-list">
    <div v-if="totalCount > 0">
      <div
        v-for="(item, index) in items"
        :key="`item-${item.id}-${index}`"
        class="paginated-list__item"
        data-test-id="paginated-list-item"
      >
        <component
          :is="componentLookup[item.type]"
          :data="item.engagement"
          v-bind="itemToProps(item)"
        />
        <ad-slot
          v-if="!excludeAds && slotForPosition(index)"
          mapping="square"
          dynamic="true"
        />
      </div>
      <pagination-controls
        :current-page="currentPage"
        :per-page="perPage"
        :total-pages="totalPages"
      />
    </div>
    <p
      v-else
      class="paginated-list__empty-message"
      data-test-id="paginated-list-empty-message"
    >
      {{ emptyMessage }}
    </p>
  </div>
</template>

<script>
import PaginationControls from '@/components/Pagination/PaginationControls.vue';
import PostTeaser from '@/components/Posts/PostTeaser.vue';
import Giveaway from '@/components/EngagementToolkit/Giveaway.vue';
import ThreadTeaser from '@/components/Forum/ThreadTeaser.vue';
import AdSlot from '@/components/Ads/AdSlot.vue';

export default {
  name: 'PaginatedList',
  components: {
    PaginationControls,
    PostTeaser,
    Giveaway,
    ThreadTeaser,
    AdSlot,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    perPage: {
      type: Number,
      default: 20,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    totalCount: {
      type: Number,
      required: true,
    },
    excludeAds: {
      type: Boolean,
      default: false,
    },
    emptyMessage: {
      type: String,
      default: 'Nothing found',
    },
  },
  data() {
    return {
      componentLookup: {
        post: 'PostTeaser',
        cas: 'PostTeaser',
        story: 'PostTeaser',
        thread: 'ThreadTeaser',
        user: 'UserTeaser',
        quiz: 'PostTeaser',
        recipe: 'PostTeaser',
        gallery: 'PostTeaser',
        sponsored_article: 'PostTeaser',
        page: 'PostTeaser',
        giveaway: 'Giveaway',
      },
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalCount / this.perPage);
    },
  },
  methods: {
    itemToProps(item) {
      const propKeyLookup = {
        post: 'post',
        cas: 'post',
        story: 'post',
        thread: 'thread',
        user: 'user',
        quiz: 'post',
        recipe: 'post',
        gallery: 'post',
        sponsored_article: 'post',
        page: 'post',
      };
      const props = {};
      props[propKeyLookup[item.type]] = item;

      if (propKeyLookup[item.type] === 'post') {
        props.featuredImageSize = 'PostThumbnail';
      }

      return props;
    },
    slotForPosition(index) {
      // Ad slots should be injected after the 7th, 14th, and 20th items on each page.
      return [6, 13, 19].includes(index);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/stylesheets/components/_paginated-list';
</style>

<docs>
Paginated List

The PaginatedList component is used to display a paginated list of any type
of teaser or other item. It uses a dynamic component to serve up a variety of
components and feeds it the appropriate props by v-binding a method that returns
those props.
</docs>
